/* eslint-disable no-undef */

// Initialize filters object
const filters = {};

function updateURL(filters) {
  const params = new URLSearchParams();

  for (const section in filters) {
    for (const filter in filters[section]) {
      const key = `${section}-${filter}`;
      params.set(key, filters[section][filter]);
    }
  }
  window.history.pushState({}, '', '?' + params.toString());
}

function initializeFilters() {
  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of params.entries()) {
    const [section, filter] = key.split('-');
    if (!filters[section]) filters[section] = {};
    filters[section][filter] = value;
  }
}

async function fetchPosts(postId, instanceId, queryArgs = {}, page = 1) {
  try {
    const response = await fetch(b3rgPostTemplateBlockData.ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: new URLSearchParams({
        action: 'b3rg_get_post_data',
        postId,
        query: JSON.stringify(queryArgs),
        page,
      }),
    });
    const data = await response.json();
    if (data.success) {
      const postTemplates = document.querySelectorAll(
        `.e-pst__post-grid[data-instance="${instanceId}"]`,
      );
      postTemplates.forEach((postTemplate) => {
        const paginationElement =
          postTemplate.parentElement.querySelector('.e-pst__pagination');
        postTemplate.innerHTML = data.data.output;
        if (paginationElement) {
          // Use insertAdjacentHTML to replace the existing pagination content
          paginationElement.insertAdjacentHTML(
            'beforebegin',
            data.data.pagination,
          );
          paginationElement.remove(); // Remove the old pagination element
        }
        postTemplate.classList.remove('loading');
      });
      // Append the filters to the URL
      updateURL(filters);
      //past event title append
      prependContentBlock();
    }
  } catch (error) {
    /* eslint-disable-next-line no-console */
    console.error('Error fetching posts:', error);
  }
}

function prependContentBlock() {
  const section = document.querySelector('.e-stn--past-events');
  if (!section) return;
  const contentBlock = section.querySelector('.e-div--content-block');
  if (!contentBlock) return;
  const row = section.querySelector('.e-pst__post-grid');
  const clonedBlock = contentBlock.cloneNode(true);
  clonedBlock.classList.add(
    'wp-block-b3rg-column',
    'e-col',
    'col-sm-12',
    'col-lg-4',
  );
  row.prepend(clonedBlock);
}

document.addEventListener('DOMContentLoaded', () => {
  const postListBlocks = document.querySelectorAll('.e-pst.e-pst--dlt');
  postListBlocks.forEach((postListBlock) => {
    // Initialize filters for this section
    const instanceId = postListBlock
      .querySelector('.e-pst__post-grid')
      ?.getAttribute('data-instance');
    filters[`section${instanceId}`] = {};
    postListBlock.addEventListener('click', (event) => {
      if (event.target.classList.contains('page-numbers')) {
        event.preventDefault();
        if (event.target.classList.contains('current')) {
          return;
        }
        // Remove 'current' class from all siblings
        const siblings = event.target.parentNode.children;
        for (const sibling of siblings) {
          sibling.classList.remove('current');
        }
        // Add 'current' class to the clicked element
        event.target.classList.add('current');
        const url = event.target.getAttribute('href');
        // Create a URLSearchParams object
        const params = new URLSearchParams(url);
        // Get the page number
        const page = params.get('page');
        // Update filters object
        filters[`section${instanceId}`].page = page;
        // Read the data-query attribute from the parent div
        let queryArgs = [];
        const blockWrapper = event.target.closest('.e-pst.e-pst--dlt');
        const postListWrapper = blockWrapper.querySelector('.e-pst__post-grid');
        if (postListWrapper && !postListWrapper.classList.contains('loading')) {
          const postId = postListWrapper.getAttribute('data-id');
          const instanceId = postListWrapper.getAttribute('data-instance');
          queryArgs = JSON.parse(postListWrapper.getAttribute('data-query'));
          postListWrapper.classList.add('loading');
          fetchPosts(postId, instanceId, queryArgs, page);
        }
      }
    });
  });
  // Initialize filters from URL
  initializeFilters();
});

/* eslint-enable no-undef */
